import { Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import index from "../../../api/auth/reservations";
import WushCard from "../../layout/WushCard";
import { addDays, format } from "date-fns";
import WushTextField from "../../form/WushTextField";
import PageLoading from "../../layout/PageLoading";
import WushPopover from "../../layout/WushPopover";
import OrderSummary from "../orders/OrderSummary";
import OrderStatusChip from "../orders/OrderStatusChip";
import ItemCategoryName from "../../text/ItemCategoryName";
import ReservationDateRange from "../../text/ReservationDateRange";

export default function UpcomingReservations() {
  const [startAt, setStartAt] = useState(format(new Date(), 'yyyy-MM-dd'));
  const [endAt, setEndAt] = useState(format(addDays(new Date(), 7), 'yyyy-MM-dd'));
  const [reservations, setReservations] = useState();
  const [reservationsLoading, setReservationsLoading] = useState(true);

  useEffect(() => {
    setReservationsLoading(true);
    index({
      status: ['confirmed', 'paid'],
      sortBy: 'start_at',
      startAt: startAt,
      endAt: endAt,
    }, (response) => {
      setReservations(response);
      setReservationsLoading(false);
    });
  }, [startAt, endAt]);

  return (
    <Stack>
      <WushCard>
        <Stack p={2}>
          <Stack mb={1}>
            <Typography variant="h5" fontWeight="bold">Upcoming Reservations ({reservations?.length})</Typography>
          </Stack>
          <Stack direction="row" mb={2} spacing={2}>
            <WushTextField type="date" label="Start Date" value={startAt} onChange={(e) => setStartAt(e.target.value)} />
            <WushTextField type="date" label="End Date" value={endAt} onChange={(e) => setEndAt(e.target.value)} />
          </Stack>
          {reservationsLoading ?
            <PageLoading />
          : <Stack spacing={1}>
            {reservations?.map((reservation) => (
              <WushPopover
                key={reservation.id}
                title="Reservation Details"
                anchor={
                  <WushCard key={reservation.id} onClick={() => console.log('')}>
                    <Stack p={1}>
                      <ItemCategoryName itemCategory={reservation.reservation_items[0].item.item_category} clickable={false} />
                      <Stack direction="row" justifyContent="space-between">
                        <Typography variant="h6">{reservation.order.customer.full_name}</Typography>
                        <OrderStatusChip order={reservation.order} />
                      </Stack>
                      <ReservationDateRange variant="body2" fontWeight={400} reservation={reservation} />
                      <Typography variant="body2"><i>{reservation.order.admin_comments}</i></Typography>
                      <Typography variant="body2"><i>{reservation.admin_comments}</i></Typography>
                      <Stack direction="row" justifyContent="space-between">
                        <Typography variant="body2">{reservation.reservation_items.length} Items</Typography>
                        <Typography variant="body2">${reservation.order.total_revenue_dollars} / ${reservation.order.grand_total_price_dollars}</Typography>
                      </Stack>
                    </Stack>
                  </WushCard>
                }
              >
                <OrderSummary order={reservation.order} forceReservations={[reservation]} />
              </WushPopover>
            ))}
          </Stack>}
        </Stack>
      </WushCard>
    </Stack>
  );
}